import { z } from "zod";

/**
 * AUDIT ZİNCİRİ DOĞRULAMA KONFİGİ (CLOS-829 · ADR-0015).
 *
 * ⚠ Sıklık neden konfigde: "bir bozulmayı en geç ne kadar sonra fark etmek istiyoruz" bir
 * güvenlik/işletme kararı, kod dalı değil (kriter 19). Doğrulama okuma yükü getiriyor;
 * dengeyi ürün sahibi kurmalı.
 */
export const auditChainConfigSchema = z.object({
  version: z.literal(1),
  verification: z.object({
    /**
     * Cron ifadesi — dakika sayısı DEĞİL.
     *
     * ⚠ Dakika tabanlı bir ayarı koda gömüp cron ifadesine çevirmek, 60'ın üstündeki her
     * değeri SESSİZCE yanlış sıklığa düşürüyor (cron'un dakika alanı 0-59). Aynı hata
     * CLOS-828'de yapıldı ve ölçülerek bulundu; burada ifadenin kendisi yazılıyor.
     */
    cron: z.string().trim().min(9).max(64),
  }),
});

export type AuditChainConfig = z.infer<typeof auditChainConfigSchema>;
